export default "__VITE_ASSET__DHPS8ZX$__"